import { forwardRef, type InputHTMLAttributes, type ReactNode } from 'react'
import { Icon } from '../Icon/Icon'
import styles from './Checkbox.module.scss'

type CheckboxProps = {
  error?: boolean
  label: ReactNode
} & InputHTMLAttributes<HTMLInputElement>

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ error = false, label, ...rest }, ref) => (
    <label className={`${styles.checkbox}${error ? ` ${styles.error}` : ''}`}>
      <input ref={ref} className={styles.input} type="checkbox" {...rest} />
      <span aria-hidden className={styles.box}>
        <Icon className={styles.mark} name="check" size={14} strokeWidth={2.5} />
      </span>
      <span>{label}</span>
    </label>
  ),
)

Checkbox.displayName = 'Checkbox'
